// SPDX-License-Identifier: AGPL-3.0-or-later

import type {MediaProxyImageSize} from '@fluxer/constants/src/MediaProxyImageSizes';

const DEFAULT_AVATAR_PRIMARY_COLORS = [0x4641d9, 0xf0b100, 0x00bba7, 0x2b7fff, 0xad46ff, 0x6a7282];
export const DEFAULT_AVATAR_COUNT = BigInt(DEFAULT_AVATAR_PRIMARY_COLORS.length);

/** Two-stop color pairs painted behind the shared default logo. White mark stays white. */
export const DEFAULT_AVATAR_TONES = [
	{from: '#4641d9', to: '#8d7cff'},
	{from: '#f0b100', to: '#ff6a2c'},
	{from: '#00bba7', to: '#2f88ff'},
	{from: '#2b7fff', to: '#7a4dff'},
	{from: '#ad46ff', to: '#ff4d88'},
	{from: '#3e4c5f', to: '#8b97a8'},
] as const;

export function getDefaultAvatarToneIndex(index: number): number {
	const count = DEFAULT_AVATAR_TONES.length;
	return ((index % count) + count) % count;
}

export function getDefaultAvatarTone(index: number): {from: string; to: string} {
	return DEFAULT_AVATAR_TONES[getDefaultAvatarToneIndex(index)];
}

export const normalizeEndpoint = (endpoint: string): string => endpoint.replace(/\/$/, '');
export const parseAvatarHash = (value: string) => {
	const animated = value.startsWith('a_');
	const hash = animated ? value.slice(2) : value;
	return {animated, hash};
};
export const buildMediaUrl = ({
	endpoint,
	path,
	id,
	hash,
	size,
	animated,
}: {
	endpoint: string;
	path: string;
	id: string;
	hash: string;
	size: MediaProxyImageSize;
	animated?: boolean;
}) => {
	const normalizedEndpoint = normalizeEndpoint(endpoint);
	const query = animated ? `size=${size}&animated=true` : `size=${size}`;
	return `${normalizedEndpoint}/${path}/${id}/${hash}.webp?${query}`;
};
export const getDefaultAvatarIndex = (id: string): number => Number(BigInt(id) % DEFAULT_AVATAR_COUNT);
export const getDefaultAvatarPrimaryColor = (id: string): number =>
	DEFAULT_AVATAR_PRIMARY_COLORS[getDefaultAvatarIndex(id)];
